import { Component, inject, OnInit } from '@angular/core';
import { AccountService } from '../../data-services/account.service';
import { UserComplete } from '../../data-services/models/account/user-complete.model';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { EventSystemsService } from '../../data-services/event-systems.service';
import { AccordionModule } from 'primeng/accordion'
import { routeTransition } from '../../route-transition';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditMenuComponent } from '../../menu/edit-menu/feature/edit-menu.component';
import { Store } from '@ngrx/store';
import { selectUserDetails } from '../../data-services/stores/selectors/user.selectors';
import { CommonModule } from '@angular/common';
import { DatePickerModule } from 'primeng/datepicker';
import { UserActions } from '../../data-services/stores/actions/user.actions';
import { EventSystemActions } from '../../data-services/stores/actions/event-system.actions';
import { selectAllEventSystems } from '../../data-services/stores/selectors/event-systems.selectors';
import { UserCustomField } from '../../data-services/models/account/user-custom-field.model';
import { Title } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-user',
  imports: [CommonModule,FormsModule,ReactiveFormsModule,InputTextModule, DatePickerModule, ToggleSwitchModule, TextareaModule,SelectModule, AccordionModule, CheckboxModule, InputNumberModule, EditMenuComponent,FontAwesomeModule],
  templateUrl: '../ui/user.component.html',
  styleUrl: '../ui/user.component.css',
  standalone: true,
  animations: [
    routeTransition,
    trigger('readyState', [
      state('fadeIn', style({
        opacity: 1,
      })),
      state('fadeOut', style({
        opacity: 0,
      })),
      transition('* => fadeOut', [animate('0.3s')]),
      transition('* => fadeIn', [animate('0.3s')]),
    ])
  ]
})
export class UserComponent implements OnInit{
  private readonly _store = inject(Store);
  private readonly _titleService = inject(Title);
  eventSystems$ = this._store.select(selectAllEventSystems)
  currentUser?: UserComplete;
  // eventSystems?: EventSystemDetailed[];
  constructor(private readonly _accountService: AccountService, private readonly _eventSystemService: EventSystemsService) {
    this._store.dispatch(UserActions.loadUser({ refresh: false}));
    this._store.dispatch(EventSystemActions.loadEventSystems());

    this._store.select(selectUserDetails).subscribe(result =>{
      this.currentUser = structuredClone(result);
    })
  }

  ngOnInit(): void {
    // this._accountService.getFullUser().then(result => this.currentUser = result);
    // this._eventSystemService.getEventSystems().then(result => this.eventSystems = result);
    this._titleService.setTitle('LRPTickets.co.uk | My Account')
  }

  selectCustomField(id:number) : UserCustomField | undefined {
    if (id) {
      return this.currentUser?.customFields?.find(x => x.customField?.customFieldID === id);
    }
    return undefined;
  }

  updateCustomField(id:number, event:any){
    if (id){
      var field = this.currentUser!.customFields!.find(x => x.customField?.customFieldID === id);
      if (field){
        field.value = event.target.value;
      }
    }
  }

  updateUser(){
    this._accountService.updateUser(this.currentUser!).subscribe();
  }
}
